import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';
import VueYoutube from 'vue-youtube-vue-3';
import { i18n } from '../../setup/i18n';
import emitter from '../../setup/bus';

export default function initSearch() {
    if (document.getElementById('app-search-page')) {
        const $appContainer = document.getElementById('app-search-page');
        const containerElement = $appContainer
            ?.closest('.container.fragment-container');
        containerElement?.classList.remove('container');
        containerElement?.classList.remove('fragment-container');
        containerElement?.classList.add('search-container');

        // eslint-disable-next-line vue/one-component-per-file
        const app = createApp({});
        const pinia = createPinia();
        app.config.globalProperties.$bus = emitter;
        app.provide('$bus', emitter);
        app.use(VueYoutube)
            .use(pinia)
            .use(i18n)
            .component(
                'Search',
                defineAsyncComponent(() => import(/* webpackChunkName: "search" */ './Search.vue'))
            )
            .component(
                'Spinner',
                defineAsyncComponent(() => import('../LoadingSpinner/LoadingSpinner.vue'))
            )
            .mount($appContainer);
    }

    if (document.querySelector('#app-search-product-list, .app-search-product-list')) {
        const instances = document.querySelectorAll('#app-search-product-list, .app-search-product-list');
        Array.prototype.forEach.call(instances, el => {
            // eslint-disable-next-line vue/one-component-per-file
            const app = createApp({});
            const pinia = createPinia();
            app.config.globalProperties.$bus = emitter;
            app.provide('$bus', emitter);
            app.use(pinia)
                .use(i18n)
                .component(
                    'ProductList',
                    defineAsyncComponent(
                        () => import(/* webpackChunkName: "search-product-list" */ './ProductList.vue')
                    )
                )
                .component(
                    'Spinner',
                    defineAsyncComponent(() => import('../LoadingSpinner/LoadingSpinner.vue'))
                )
                .mount(el);
        });
    }
}
